import nearestColor from 'nearest-color';

// Simple set of basic colors to avoid subjective & ambiguous names
// such as 'Tulip tree' or 'Saffron Mango'
const colorSetBasic = {
    black: '#000000',
    'dark grey': '#404040',
    grey: '#808080',
    'light grey': '#D3D3D3',
    white: '#FFFFFF',

    // Blues
    blue: '#0000FF',
    'royal blue': '#4169E1',
    navy: '#000080',
    'dark navy': '#00004d',
    'sky blue': '#87CEEB',
    'light blue': '#ADD8E6',
    cyan: '#00FFFF',
    turquoise: '#40E0D0',
    aqua: '#00FFFF',
    teal: '#008080',

    // Greens
    green: '#008000',
    'dark green': '#006400',
    'forest green': '#228B22',
    'deep green': '#003b00',
    'olive green': '#3e483c',
    'lime green': '#00FF00',
    'mint green': '#98FF98',
    'light green': '#90EE90',
    'pastel green': '#2E8B57',

    // Purples
    purple: '#800080',
    'dark purple': '#4B0082',
    lavender: '#E6E6FA',
    violet: '#EE82EE',
    'light purple': '#D8B9D3',
    magenta: '#FF00FF',
    plum: '#8E4585',

    // Browns
    brown: '#A0522D',
    'dark brown': '#654321',
    tan: '#D2B48C',
    beige: '#F5F5DC',
    'light brown': '#C3B091',
    'chocolate brown': '#7B3F00',
    'deep brown': '#8B4513',

    // Reds
    red: '#FF0000',
    burgundy: '#9E1B32',
    'dark red': '#c9454a',
    'deep red': '#8B0000',
    maroon: '#800000',
    crimson: '#DC143C',
    scarlet: '#FF2400',
    'reddish pink': '#CB4154',

    // Oranges
    orange: '#FFA500',
    'dark orange': '#FF8C00',
    gold: '#FFD700',
    peach: '#FFDAB9',
    apricot: '#FBCEB1',
    'light orange': '#FFB84D',

    // Pinks
    pink: '#FF69B4',
    'hot pink': '#FF00FF',
    'deep pink': '#FF1493',
    'light pink': '#FFC0CB',
    'pastel pink': '#F4C2C2',
    'blush pink': '#F1C6C6',

    // Yellows
    yellow: '#FFFF00',
    mustard: '#FFDB58',
    'bright yellow': '#FFF700',
    'golden yellow': '#DAA520',
    'light yellow': '#FFFFE0',
};

export const getColorName = (hex: string): string | undefined => {
    const getNearestColorName = nearestColor.from(colorSetBasic);
    const nearest = getNearestColorName(hex);
    return nearest?.name;
};

export const getSimpleLayoutName = (layoutName: string): string | undefined => {
    const layoutMap: Record<string, string> = {
        stacked: 'stacked',
        sideByside: 'side by side',
        archIconLayout: 'arch',
        rectangle_border: 'rectangular',
        circular: 'circular',
    };
    return Object.entries(layoutMap).find(([key]) => layoutName.includes(key))?.[1];
};
